import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType, GaTrackingEventLabel } from '../../constants';

export class GATrackingScrollingEvent implements GATrackingEvent {

  constructor(private payload: {page: GATrackingEventType, element: GaTrackingEventLabel}) {
  }

  getEventTypeFromPage(): GATrackingEventType {
    return this.payload.page;
  }

  getEventType(): GATrackingEventType {
    return this.getEventTypeFromPage();
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: 'scrolling',
      label: `${this.payload.element} visible`
    };
  }
}
